<template>
  <div class="select-local">
    <b-form-input v-model="search" type="text" required placeholder="Buscar"></b-form-input>
    <div class="box" v-if="showOptions">
      <ul class="box-list">
        <li v-for="itemSearch in itemsSearch" :key="itemSearch.id" class="box-item" @click.prevent="selectItem(itemSearch)">
          {{ itemSearch.name }}
        </li>
      </ul>            
    </div>
  </div>
</template>

<script>
  export default {
    name: 'SelectLocal',
    props: ['model', 'items'],
    methods: {
      selectItem(item) {
        this.modelLocal = item.id
        this.search = item.name
        this.fill = true
        this.showOptions = false
      },
      searchCity() {
        let item = this.items.filter(item => item.id == this.model)[0]
        this.modelLocal = item.id
        this.search = item.name  
        this.searchDataCity = false      
      }
    },
    watch: {
      search() {
        if(this.search.length > 0){
          this.itemsSearch = this.items.filter(itemFilter => itemFilter.name.toLowerCase().includes(this.search.toLowerCase()))
          if( !this.fill && this.itemsSearch.length > 0){
            this.showOptions = true
          }else{
            this.fill = false
          }          
        }
      },
      items (oldValue, newValue) {
        if (this.searchCity) {
          this.searchCity()
        }        
      }
    },
    data() {
      return {
        showOptions: false,
        search: '',
        itemsSearch: [],
        fill: true,
        searchDataCity: true
      }
    },
    computed: {
      modelLocal: {
        get () {
          return this.model
        },
        set (value){
          this.$emit("update:model", value)
        }      
      }
    }
  }
</script>

<style scoped>
.box {
  position: absolute;
  padding: 0.5rem;
  color: #58595c;
  font-size: 15px;
  overflow-y: scroll;
  height: 120px;
  width: max-content;
  background-color: #ffffff;
  border: 1px solid #dddcdc;
  border-radius: 5px;
}
.box-list{
  list-style: none;
  padding-left: 0.1rem;
}
.box-item{
  cursor: pointer;
}
</style>